// NOTE: the option key is intentionally the misspelled "inmediate" to preserve
// the existing call-site contract (see debounce.test.ts).
interface DebounceOptions {
  inmediate?: boolean
}

export function debounce<Args extends unknown[]>(
  fn: (...args: Args) => void,
  wait = 0,
  options: DebounceOptions = {},
): (...args: Args) => void {
  let timeout: ReturnType<typeof setTimeout> | undefined

  return (...args: Args) => {
    const inmediate =
      'inmediate' in options ? !!options.inmediate : options.inmediate
    const later = () => {
      timeout = undefined
      if (!inmediate) fn(...args)
    }
    const now = inmediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (now) fn(...args)
  }
}
